"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitProposalRequestSchema = exports.submitProposalRequestByAdminOrEditorSchema = exports.submitProposalRequestByReviewerSchema = exports.baseSubmitProposalRequestSchema = void 0;
const zod_1 = require("zod");
const userWithUserId_schema_1 = require("../../../common/schemas/userWithUserId.schema");
const longField_schema_1 = require("../../../common/schemas/longField.schema");
const selectedItem_schema_1 = require("../../../common/schemas/selectedItem.schema");
const attachments_schema_1 = require("../../../common/schemas/attachments.schema");
const Purpose_1 = require("../../types/Purpose");
const contact_schema_1 = require("../../../common/schemas/contact.schema");
const shortField_schema_1 = require("../../../common/schemas/shortField.schema");
const ReceivedVia_1 = require("../../types/ReceivedVia");
const datetime_schema_1 = require("../../../common/schemas/datetime.schema");
const amountWithCurrency_schema_1 = require("../common/amountWithCurrency.schema");
exports.baseSubmitProposalRequestSchema = zod_1.z
    .object({
    purpose: (0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(Purpose_1.Purpose, [
        Purpose_1.Purpose.ForReview,
        Purpose_1.Purpose.ForConstruction,
        Purpose_1.Purpose.ForInformationOnly,
    ]),
    remarks: longField_schema_1.longFieldSchema.optional(),
    from: contact_schema_1.contactSchema,
    to: userWithUserId_schema_1.userWithUserIdSchema.array().nonempty(),
    cc: contact_schema_1.contactSchema.array().optional(),
    proposedTotalAmount: amountWithCurrency_schema_1.amountWithCurrencySchema.optional(),
    proposedTotalDays: zod_1.z.number().nonnegative().int().optional(),
    contractorSenderNumber: shortField_schema_1.shortFieldSchema.optional(),
    version: zod_1.z.string(),
    attachments: attachments_schema_1.optionalAttachmentsSchema,
})
    .strict();
exports.submitProposalRequestByReviewerSchema = exports.baseSubmitProposalRequestSchema
    .extend({
    isReviewer: zod_1.z.literal(true),
})
    .strict();
exports.submitProposalRequestByAdminOrEditorSchema = exports.baseSubmitProposalRequestSchema
    .extend({
    isReviewer: zod_1.z.literal(false),
    receivedVia: (0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(ReceivedVia_1.ReceivedVia).required(),
    receivedDate: datetime_schema_1.datetimeSchema,
})
    .strict();
exports.submitProposalRequestSchema = zod_1.z.union([
    exports.submitProposalRequestByReviewerSchema,
    exports.submitProposalRequestByAdminOrEditorSchema,
]);
//# sourceMappingURL=submitProposalRequest.schema.js.map